import { useState } from 'react';

// Define los tipos para los campos de ordenamiento
export type SortField = 'name' | 'category' | 'locality' | 'region' | 'phone' | 'status' | 'capacity' | 'estadoObservado' | '';
export type SortDirection = 'asc' | 'desc';

// Define los tipos para los filtros
export interface SearchFilters {
  categories: string[];
  localities: string[];
  services: string[];
  accessibility: string;
  type?: string[]; // Added to match Filter
  category?: string[]; // Added to match Filter
  status?: string[]; // Added to match Filter
  substatus?: string[];
  region?: string[]; // Added to match Filter
  segment?: string[]; // Added to match Filter
  hasEventRoom?: boolean; // Added to match Filter
}

// Define the Filter type to be exported
export type Filter = {
  type: string[];
  category: string[];
  status: string[];
  substatus: string[];
  region: string[];
  locality: string[];
  segment: string[];
  accessibility: string;
  services: Record<string, boolean>;
  hasEventRoom: boolean;
};

// Hook para manejar la búsqueda y filtrado
export const useSearch = () => {
  // Estado para el query de búsqueda
  const [searchQuery, setSearchQuery] = useState('');
  
  // Estado para los filtros - update to use Filter type instead of SearchFilters
  const [filters, setFilters] = useState<Filter>({
    type: [],
    category: [],
    status: [],
    substatus:[],
    region: [],
    locality: [],
    segment: [],
    accessibility: '',
    services: {},
    hasEventRoom: false
  });
  
  // Estado para el ordenamiento
  const [sortField, setSortField] = useState<SortField>('');
  const [sortDirection, setSortDirection] = useState<SortDirection>('asc');
  
  // Maneja el cambio en el campo de búsqueda
  const handleSearchChange = (value: string) => {
    setSearchQuery(value);
  };
  
  // Maneja el cambio en los filtros
  const handleFilterChange = (field: string, value: string | string[]) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };
  
  // Aplica los filtros a los resultados
  const applyFilters = () => {
    console.log('Applying filters', filters);
    // Aquí iría la lógica para aplicar los filtros a los resultados
  };
  
  // Limpia todos los filtros
  const clearFilters = () => {
    setFilters({
      type: [],
      category: [],
      status: [],
      substatus:[],
      region: [],
      locality: [],
      segment: [],
      accessibility: '',
      services: {},
      hasEventRoom: false
    });
  };
  
  // Elimina un filtro específico
  const removeFilter = (filter: string) => {
    const [field, value] = filter.split(':');
    
    setFilters(prev => {
      if (field === 'accessibility') {
        return { ...prev, accessibility: '' };
      }
      
      if (Array.isArray(prev[field as keyof Filter])) {
        return {
          ...prev,
          [field]: (prev[field as keyof Filter] as string[]).filter(v => v !== value)
        };
      }
      
      return prev;
    });
  };
  
  // Maneja el cambio en el ordenamiento
  const handleSortChange = (field: SortField) => {
    if (sortField === field) {
      // Si ya estamos ordenando por este campo, cambiamos la dirección
      setSortDirection(prev => prev === 'asc' ? 'desc' : 'asc');
    } else {
      // Si no, ordenamos por este campo en ascendente
      setSortField(field);
      setSortDirection('asc');
    }
  };
  
  return {
    searchQuery,
    filters,
    sortField,
    sortDirection,
    handleSearchChange,
    handleFilterChange,
    applyFilters,
    clearFilters,
    removeFilter,
    handleSortChange
  };
};
